module.exports = __webpack_public_path__ + "img/icon_star_rate_active.2f58f564.svg";